import { render, staticRenderFns } from "./ShippingSettings.vue?vue&type=template&id=0acd8d72&"
import script from "./ShippingSettings.vue?vue&type=script&lang=js&"
export * from "./ShippingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports